import React from "react";
import PageLayout from "../components/pageLayout";
import GetInTouch from "../components/getInTuoch";
import { sectionBlocks, useSiteData } from "../lib/siteApi";

export default function ContactPage() {
  const site = useSiteData();
  const block = sectionBlocks(site.content, "contact")[0];

  return (
    <PageLayout
      eyebrow="Contact"
      title={block?.title || "Let’s plan your next clean-energy project"}
      summary={block?.body || "Call, email, or send the form. The RENERG team in Kigali will reply with a clear next step."}
      roomy
    >
      <GetInTouch bare />
    </PageLayout>
  );
}
